import React, { Fragment, useState } from "react";
import "../Reporting.css";
import ReportingModals from "../../../../shared/Modals/ReportingModals";
import arrowImg from "../../../../assets/purple.svg";
import { countPatientsByMonthYear } from "../api";
import { useSelector } from "react-redux";
import { Group } from "@visx/group";
import { AxisLeft, AxisBottom } from "@visx/axis";
import { scaleLinear, scaleBand } from "@visx/scale";
import { LinePath } from "@visx/shape";
import { Tooltip, useTooltip } from "@visx/tooltip";
import { ParentSize } from "@visx/responsive";
import { curveMonotoneX } from "@visx/curve";

const PatientsYear = (props) => {
  const [lgShow, setLgShow] = useState(false);
  const patientsList = useSelector((state) => state.patients.patientList.data);
  const [data, setData] = useState([]);
  const { showTooltip, hideTooltip, tooltipData, tooltipLeft, tooltipTop } = useTooltip();

  React.useEffect(() => {
    if (patientsList && patientsList.length > 0) {
      const patientCounts = countPatientsByMonthYear(patientsList);
      // Get the last 12 months of data or all if less than 12
      const last12Months = patientCounts.slice(-12);
      setData(last12Months);
    } else {
      setData([]);
    }
  }, [patientsList]);

  // Chart component
  const Chart = ({ width, height }) => {
    // Early return if no data
    if (!data.length) return null;

    // Chart dimensions
    const margin = { top: 20, right: 30, bottom: 40, left: 50 };
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    // Scales
    const xScale = scaleBand({
      domain: data.map(d => `${d.month} ${d.year}`),
      range: [0, innerWidth],
      padding: 0.2,
    });

    const yScale = scaleLinear({
      domain: [0, Math.max(...data.map(d => d.totalCount)) * 1.1], // Add 10% padding
      range: [innerHeight, 0],
      nice: true,
    });

    // Colors
    const lineColor = "#6b46c1"; // Purple color matching the arrow
    const tickLabelColor = "#444";

    return (
      <div style={{ position: 'relative' }}>
        <svg width={width} height={height}>
          <Group left={margin.left} top={margin.top}>
            {/* Grid lines */}
            {yScale.ticks().map(tick => (
              <line
                key={`grid-${tick}`}
                x1={0}
                x2={innerWidth}
                y1={yScale(tick)}
                y2={yScale(tick)}
                stroke="#e0e0e0"
                strokeDasharray="2,2"
              />
            ))}

            {/* Axes */}
            <AxisLeft
              scale={yScale}
              stroke="#888"
              tickStroke="#888"
              tickLabelProps={() => ({
                fill: tickLabelColor,
                fontSize: 11,
                textAnchor: 'end',
                dy: '0.33em',
                dx: '-0.33em',
              })}
              label="Patients"
              labelProps={{
                fill: tickLabelColor,
                fontSize: 12,
                textAnchor: 'middle',
                dx: -35,
              }}
            />
            <AxisBottom
              top={innerHeight}
              scale={xScale}
              stroke="#888"
              tickStroke="#888"
              tickLabelProps={() => ({
                fill: tickLabelColor,
                fontSize: 11,
                textAnchor: 'middle',
                dy: '0.33em',
              })}
              tickFormat={value => value.split(' ')[0].substring(0, 3)} // Show first 3 letters of month
              label="Month"
              labelProps={{
                fill: tickLabelColor,
                fontSize: 12,
                textAnchor: 'middle',
                dy: 35,
              }}
            />

            {/* Line chart */}
            <LinePath
              data={data}
              x={d => xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2}
              y={d => yScale(d.totalCount)}
              stroke={lineColor}
              strokeWidth={3}
              curve={curveMonotoneX}
            />

            {/* Data points */}
            {data.map((d, i) => (
              <circle
                key={`circle-${i}`}
                cx={xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2}
                cy={yScale(d.totalCount)}
                r={5}
                fill="#fff"
                stroke={lineColor}
                strokeWidth={2}
                onMouseEnter={() => {
                  const x = xScale(`${d.month} ${d.year}`) + xScale.bandwidth() / 2;
                  const y = yScale(d.totalCount);
                  showTooltip({
                    tooltipData: d,
                    tooltipLeft: x + margin.left,
                    tooltipTop: y + margin.top,
                  });
                }}
                onMouseLeave={hideTooltip}
                style={{ cursor: 'pointer' }}
              />
            ))}
          </Group>
        </svg>

        {tooltipData && (
          <div
            style={{
              position: 'absolute',
              top: tooltipTop - 40,
              left: tooltipLeft,
              transform: 'translateX(-50%)',
              backgroundColor: 'white',
              color: 'black',
              padding: '0.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              fontSize: '12px',
              pointerEvents: 'none',
              zIndex: 9999,
              width: 'auto',
              minWidth: '120px',
              textAlign: 'center',
            }}
          >
            <div style={{ fontWeight: 'bold' }}>{`${tooltipData.month} ${tooltipData.year}`}</div>
            <div>{`Patients: ${tooltipData.totalCount}`}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Fragment>
      <div
        onClick={(e) => { props?.check ? setLgShow(true) : e.preventDefault(); }}
        className="d-flex align-items-center pl-4 pt-2"
      >
        <p className="review-txt"> New patients month by month </p>
        <img src={arrowImg} alt="" className="arrow-img ml-2" />
      </div>
      <div id={props?.divId} style={{ height: props?.check === false ? "400px" : "230px", width: "100%" }}>
        <ParentSize>
          {({ width, height }) => <Chart width={width} height={height} />}
        </ParentSize>
      </div>
      {setLgShow ? (
        <ReportingModals
          setLgShow={setLgShow}
          lgShow={lgShow}
          show={2}
          title={"New patients month by month"}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
};
export default PatientsYear;
